import { ReactNode } from 'react';
import BackToTop from './BackToTop';
import Footer from './Footer';
import Header from './Header';
import { useReveal } from '../hooks/useReveal';

function Layout({ children }: { children: ReactNode }) {
  useReveal();

  return (
    <div className="App">
      <Header />
      <main>{children}</main>
      <Footer />
      <BackToTop />
    </div>
  );
}

export default Layout;
